import { useTranslation, Trans } from "react-i18next";
import { useState } from "react";

import Button from "../Button";

function Accounts () {

    const { t } = useTranslation();

    const accounts = [
    {
        name: t('accountData.standard.name'),
        deposit: t('accountData.standard.deposit'),
        targetAudience: t('accountData.standard.targetAudience'),
        spreads: t('accountData.standard.spreads'),
        commission: t('accountData.standard.commission'),
        keyFeatures: [
        t('accountData.standard.keyFeatures.0'),
        t('accountData.standard.keyFeatures.1'),
        t('accountData.standard.keyFeatures.2'),
        t('accountData.standard.keyFeatures.3')
        ],
        bonus: t('accountData.standard.bonus')
    },
    {
        name: t('accountData.smartStart.name'),
        deposit: t('accountData.smartStart.deposit'),
        targetAudience: t('accountData.smartStart.targetAudience'),
        spreads: t('accountData.smartStart.spreads'),
        commission: t('accountData.smartStart.commission'),
        keyFeatures: [
        t('accountData.smartStart.keyFeatures.0'),
        t('accountData.smartStart.keyFeatures.1'),
        t('accountData.smartStart.keyFeatures.2'),
        t('accountData.smartStart.keyFeatures.3')
        ],
        bonus: t('accountData.smartStart.bonus')
    },
    {
        name: t('accountData.fullPackage.name'),
        deposit: t('accountData.fullPackage.deposit'),
        targetAudience: t('accountData.fullPackage.targetAudience'),
        spreads: t('accountData.fullPackage.spreads'),
        commission: t('accountData.fullPackage.commission'),
        keyFeatures: [
        t('accountData.fullPackage.keyFeatures.0'),
        t('accountData.fullPackage.keyFeatures.1'),
        t('accountData.fullPackage.keyFeatures.2'),
        t('accountData.fullPackage.keyFeatures.3')
        ],
        bonus: t('accountData.fullPackage.bonus')
    },
    {
        name: t('accountData.vip.name'),
        deposit: t('accountData.vip.deposit'),
        targetAudience: t('accountData.vip.targetAudience'),
        spreads: t('accountData.vip.spreads'),
        commission: t('accountData.vip.commission'),
        keyFeatures: [
        t('accountData.vip.keyFeatures.0'),
        t('accountData.vip.keyFeatures.1'),
        t('accountData.vip.keyFeatures.2'),
        t('accountData.vip.keyFeatures.3')
        ],
        bonus: t('accountData.vip.bonus')
    }
    ];


    const [selectedAccount, setSelectedAccount] = useState(0);
      
    return(
        <div className="overflow-hidden relative z-50">
            <div className="w-full h-[40px] xl:h-[60px] bg-[#131313]"></div>
            <div className="w-full h-[40px] xl:h-[60px] rounded-t-[40px] xl:rounded-t-[60px] bg-white mt-[-40px] xl:mt-[-60px]"></div>
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto mt-[60px] xl:mt-[80px]">
               <div>
                    <table className="w-full xl:flex flex-col hidden">
                        <thead>
                            <tr className="flex items-center justify-between">
                                <th className="roboto pl-[20px] text-[#000000B2] text-left font-[500] text-[14px] xl:text-[16px] xl:w-[200px]">{t('account.3')}</th>
                                {accounts.map((account, index) => (
                                    <th
                                        key={index}
                                        className={`border ${index === 0 ? 'border-[#131313]' : ''} ${index === 1 ? 'bg-[#131313]' : ''} ${index === 2 ? 'bg-[#D3D3D3]' : ''} ${index === 3 ? 'bg-[#A3E9E6]' : ''} rounded-[20px] xl:w-[230px] py-[15px]`}
                                    >
                                        <p className={`text-[#131313] uppercase manrope text-[24px] ${index === 1 ? 'text-[#FFFFFF]' : ''}`}>{account.name}</p>
                                        <p className={`manrope text-[#131313] text-[14px] xl:text-[16px] ${index === 1 ? 'text-[#FFFFFF]' : ''}`}>{t('account.12')}</p>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="flex items-center justify-between mt-[10px] border-b border-[#13131380]">
                                <td className="roboto pl-[20px] text-[#000000B2] font-[500] text-[14px] xl:text-[16px] text-left xl:w-[200px]">{t('account.4')}</td>
                                {accounts.map((account, index) => (
                                    <td

                                        key={index}
                                        className={`roboto text-center font-[500] xl:w-[230px] text-[#131313] text-[16px] xl:text-[20px]  py-[10px]`}
                                    >
                                        {account.deposit}
                                    </td>
                                ))}
                            </tr>

                            <tr className="flex items-center justify-between mt-[0px] border-b border-[#13131380]">
                                <td className="roboto pl-[20px] text-[#000000B2] font-[500] text-[14px] xl:text-[16px] text-left xl:w-[200px]">{t('account.5')}</td>
                                {accounts.map((account, index) => (
                                    <td

                                        key={index}
                                        className={`roboto xl:w-[230px] text-[#000000B2] text-[14px] xl:text-[16px]  py-[10px]`}
                                    >
                                        {account.targetAudience}
                                    </td>
                                ))}
                            </tr>

                            <tr className="flex items-center justify-between mt-[0px] border-b border-[#13131380]">
                                <td className="roboto pl-[20px] text-[#000000B2] font-[500] text-[14px] xl:text-[16px] text-left xl:w-[200px]">{t('account.7')}</td>
                                {accounts.map((account, index) => (
                                    <td

                                        key={index}
                                        className={`roboto xl:w-[230px] text-[#000000B2] text-[14px] xl:text-[16px]  py-[10px]`}
                                    >
                                        {account.spreads}
                                    </td>
                                ))}
                            </tr>

                            <tr className="flex items-center justify-between mt-[0px] border-b border-[#13131380]">
                                <td className="roboto pl-[20px] text-[#000000B2] font-[500] text-[14px] xl:text-[16px] text-left xl:w-[200px]">{t('account.10')}</td>
                                {accounts.map((account, index) => (
                                    <td

                                        key={index}
                                        className={`roboto xl:w-[230px] text-[#000000B2] text-[14px] xl:text-[16px]  py-[10px]`}
                                    >
                                        {account.commission}
                                    </td>
                                ))}
                            </tr>

                            <tr className="flex items-start justify-between mt-[0px] border-b border-[#13131380]">
                                <td className="roboto pl-[20px] py-[10px] text-[#000000B2] font-[500] text-[14px] xl:text-[16px] text-left xl:w-[200px]">{t('account.11')}</td>
                                {accounts.map((account, index) => (
                                    <td
                                        key={index}
                                        className={`xl:w-[230px] py-[10px] text-[14px] text-left`}
                                    >
                                        <ul className="list-disc ml-4 text-[#000000B2] roboto">
                                            {account.keyFeatures.map((f, j) => (
                                                <li key={j}>{f}</li>
                                            ))}
                                        </ul>
                                    </td>
                                ))}
                            </tr>

                            <tr className="flex items-center justify-between mt-[0px] border-b border-[#13131380]">
                                <td className="roboto pl-[20px] text-[#000000B2] font-[500] text-[14px] xl:text-[16px] text-left xl:w-[200px]">Bonus Program</td>
                                {accounts.map((account, index) => (
                                    <td

                                        key={index}
                                        className={`roboto xl:w-[230px] text-[#000000B2] text-[14px] xl:text-[16px]  py-[10px]`}
                                    >
                                        {account.bonus}
                                    </td>
                                ))}
                            </tr>
                        </tbody>
                        
                    </table>
                    {/* ======= MOBILE VERSION ======= */}
                    <div className="block xl:hidden">
                        {/* Кнопки выбора аккаунта */}
                        <div className="grid grid-cols-2 gap-3 mb-6">
                        {accounts.map((acc, index) => (
                            <button
                                key={acc.name}
                                onClick={() => setSelectedAccount(index)}
                                className={`py-3 rounded-xl border text-sm font-medium transition-all manrope text-[16px] ${
                                    selectedAccount === index
                                    ? "bg-[#A3E9E6] border-[#A3E9E6] text-black"
                                    : "border-[#131313] text-[#131313]"
                                }`}
                            >
                                <span className="manrope text-[16px] font-[600] text-[#131313]">{acc.name}</span> <br />
                                <span className="text-[14px] text-[#131313]">{t('account.12')}</span>
                            </button>
                        ))}
                        </div>

                        {/* Информация по выбранному аккаунту */}
                        <div className="p-5 bg-white flex flex-col">
                        <div className="flex justify-between text-[12px] mb-2 roboto">
                            <span>{t('account.4')}</span>
                            <span className="font-medium text-[#000E59] !text-[16px]">
                            {accounts[selectedAccount].deposit}
                            </span>
                        </div>
                        <div className="flex justify-between text-[12px] mb-2 roboto">
                            <span>{t('account.5')}</span>
                            <span>{accounts[selectedAccount].targetAudience}</span>
                        </div>
                        <div className="flex justify-between text-[12px] mb-2 roboto">
                            <span>{t('account.7')}</span>
                            <span>{accounts[selectedAccount].spreads}</span>
                        </div>
                        <div className="flex justify-between text-[12px] mb-2 roboto">
                            <span>{t('account.10')}</span>
                            <span>{accounts[selectedAccount].commission}</span>
                        </div>
                        <div className="flex justify-between text-[12px] mb-2 roboto">
                            <span>Bonus Program</span>
                            <span>{accounts[selectedAccount].bonus}</span>
                        </div>
                        <div className="flex flex-col text-[12px] mb-5 roboto">
                            <span className="mb-2">{t('account.11')}</span>
                            <ul className="list-disc ml-5">
                              {accounts[selectedAccount].keyFeatures.map((f, i) => (
                                <li key={i} className="text-[12px]">{f}</li>
                              ))}
                            </ul>
                        </div>

                        {/* Кнопка */}
                        <Button className="mx-auto mt-4" />
                        </div>
                    </div>
               </div>
            </div>
        </div>
    );
}

export default Accounts;
